import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials, businessInfo } from '../../data/mock';
import { Card, CardContent } from '../ui/card';

export const TestimonialsSection = () => {
  return (
    <section id="ulasan" className="relative bg-black py-24 lg:py-32 overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#00FFD1]/5 rounded-full blur-[120px]" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-[#00FFD1] text-sm font-medium tracking-wider uppercase mb-4">
            Ulasan Pelanggan
          </span>
          <h2 className="text-white text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight mb-6">
            Apa Kata{' '}
            <span className="text-[#00FFD1]">Pelanggan Kami</span>
          </h2>
          
          {/* Overall Rating */}
          <div className="inline-flex flex-col items-center gap-3 bg-white/5 border border-white/10 px-8 py-6 mt-4">
            <div className="flex items-center gap-2">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 fill-[#00FFD1] text-[#00FFD1]" />
              ))}
            </div>
            <div className="text-center">
              <span className="text-white text-3xl font-bold">{businessInfo.rating}</span>
              <span className="text-white/60 text-lg"> / 5</span>
            </div>
            <span className="text-white/50 text-sm">
              Berdasarkan {businessInfo.totalReviews} ulasan
            </span>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((testimonial) => (
            <Card
              key={testimonial.id}
              className="bg-[#121212] border-white/10 hover:border-[#00FFD1]/20 transition-all duration-400"
            >
              <CardContent className="p-8">
                {/* Quote Icon */}
                <Quote className="w-10 h-10 text-[#00FFD1]/30 mb-4" />

                {/* Rating */}
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-[#00FFD1] text-[#00FFD1]" />
                  ))}
                </div>

                {/* Comment */}
                <p className="text-white/80 text-lg leading-relaxed mb-6">
                  "{testimonial.comment}"
                </p>

                {/* Author */}
                <div className="flex items-center justify-between pt-4 border-t border-white/10">
                  <div>
                    <h4 className="text-white font-semibold">{testimonial.name}</h4>
                    <p className="text-white/50 text-sm">{testimonial.location}</p>
                  </div>
                  <span className="text-white/40 text-sm">{testimonial.date}</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
